import request from "@/utils/request";

export default function listByProductId(productId) {
    return request({
        url: `/storeProductSpecificationValue/agency/listByProductId/`+productId,
        method: 'get',
    })
}
